import request from '@/utils/request'

/**
 * 导入孩子信息
 * @param data
 */
export function exportUserChild(data) {
  return request({
    url: '/admin/export/exportUserChild',
    method: 'post',
    data: data
  })
}

export function exportUserBuyCard(data) {
  return request({
    url: '/admin/export/exportUserBuyCard',
    method: 'post',
    data: data
  })
}







// WEBPACK FOOTER //
// ./src/api/export.js